/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseValidator} from "./BaseValidator";
import React from "react";

export class SpeciesTypeValidator extends BaseValidator {
	logic(value, model, data) {
		return !(data?.speciesId && Number(value) === 5);
	}

	message(value, model, data) {
		return "Cannot be 'Other'";
	}
}
